import React from "react"

import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-social.module.scss"
import Grid from "../../atoms/grid"

const NewsletterSocial = ({ section }) => (
  <Grid nowrap tight col={section.posts.length}>
    {section.posts.map((post) => (
      <div>
        <a href={post.url} target="_blank" rel="noreferrer">
          <Image
            className={styles.post}
            {...post.image}
            width={400}
            alt={post.caption}
          />
        </a>
        <div className={styles.caption}>{post.caption}</div>
      </div>
    ))}
  </Grid>
)

export default NewsletterSocial

NewsletterSocial.propTypes = {
  section: PropTypes.object.isRequired,
}
